import { useEffect } from "react";
import ImageGallery from "@/components/ImageGallery";

const Index = () => {
  // Keep gallery as the only landing view
  useEffect(() => {
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute('content', '#ffffff');
    }
  }, []);

  return (
    <main className="min-h-screen" style={{ backgroundColor: '#ffffff' }}>
      <ImageGallery />
    </main>
  );
};

export default Index;
